import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const PlateIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="34"
      height="28"
      viewBox="0 0 34 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7471 22.4332C22.4335 22.4332 26.2325 18.6342 26.2325 13.9478C26.2325 9.26145 22.4335 5.4624 17.7471 5.4624C13.0608 5.4624 9.26172 9.26145 9.26172 13.9478C9.26172 18.6342 13.0608 22.4332 17.7471 22.4332Z"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4297 3.43058C12.5061 1.98268 15.0316 1.14087 17.7478 1.14087C21.3395 1.14087 24.5833 2.62245 26.9066 5.00195"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8056 23.0054C24.4822 25.3288 21.2834 26.7542 17.7478 26.7542C15.0316 26.7542 12.5061 25.9012 10.4297 24.4645"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.42383 1.8479V6.61814"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75977 1.8479V6.61814"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1.8479V6.76405C1 8.36909 1.9765 9.73843 3.34583 10.2435V24.3971C3.34583 25.0481 3.87337 25.5644 4.51314 25.5644C5.16414 25.5644 5.68044 25.0369 5.68044 24.3971V10.2435C7.04978 9.73843 8.02628 8.36909 8.02628 6.76405V1.8479"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 2.61104V24.3633C33 25.0255 32.4612 25.5643 31.799 25.5643C31.1368 25.5643 30.5868 25.0255 30.5868 24.3633V15.2494C29.5317 15.2381 28.746 14.2392 28.993 13.2178L31.5296 2.44268C31.7429 1.57843 33 1.72434 33 2.61104Z"
        stroke={color ?? 'current-color'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlateIcon;
